const experimentSettingsJson = {
  "totalNumberOfTrialsToRun": 5,
  "advancementSchedule": 2,
  "regressionSchedule": 0,
  "language": "fr",
  "seed": undefined,
  "initialDifficulty": 5,
  "numberOfLevels": 9,
  "downloadOnFinish": false,
}
export { experimentSettingsJson }
